module.exports = __webpack_public_path__ + "img/c1.2309fb51.jpg";